// extracted by mini-css-extract-plugin
module.exports =  {"buttons":"E1oV3iR"};